<template>
    <div class="main">
        <ul>
            <router-link v-for="(item,index) in nav" :key="index" :to="item.path" tag="li">
                <img :src="item.src" alt="">
                <p>{{item.name}}</p>
            </router-link>
        </ul>
    </div>
</template>

<script>
export default {
    data(){
        return{
            isShowLink: false,
            name:'',
            school:'',
            sexName:'',
            parameter:'',
            nav: [
                { name: '学生信息', idx: '0', path: '/studyPlan/studentMessage',src:'/imgs/studyPlan/icon_01.png', src2:'/imgs/studyPlan/icon_h_01.png' },
                { name: '规划内容', idx: '1', path: '/studyPlan/planningContent',src:'/imgs/studyPlan/icon_02.png',src2:'/imgs/studyPlan/icon_h_02.png' },
                { name: '计划执行', idx: '2', path: '/studyPlan/implement/targetsplit',src:'/imgs/studyPlan/icon_03.png',src2:'/imgs/studyPlan/icon_h_03.png' },
                { name: '咨询记录', idx: '3', path: '/studyPlan/consultationRecord',src:'/imgs/studyPlan/icon_04.png',src2:'/imgs/studyPlan/icon_h_04.png' },
                { name: '数据分析', idx: '4', path: '/studyPlan/dataAnalysis/grade',src:'/imgs/studyPlan/icon_05.png',src2:'/imgs/studyPlan/icon_h_05.png' },
                { name: '成长档案', idx: '5', path: '/studyPlan/growthFile',src:'/imgs/studyPlan/icon_06.png',src2:'/imgs/studyPlan/icon_h_06.png' },
            ],
          query:''
        }
    },
    beforeCreate() {

    },
    computed:{
        // studentStatus() {
        //     return this.$store.state.studentStatus;
        // }
    },
    created() {
        // if(this.studentStatus!=3) {
        //     this.$router.push('/studyPlan/studentQues');
        // }else {
        //     this.isShowLink = true;
        // }
    },
    mounted() {
            this.$ajax.post(this.G_uri + '/powerTech/check', {
                  route:'/studyPlan/main'
                },{
                    headers: {
                        token: window.sessionStorage.getItem("ymtxToken")
                    }
                }).then(res=>{
                    console.log(res,'返回判断有没有当前地址')
                    if(res.data.code == 2000){

                    }else{
                        this.$router.push('/NotFind')
                    }
                }) 

    },
    methods:{
        // getData(){
        //     this.$ajax.post(this.G_acapi + this.ports.consultant.student.new.getStudentDetail,{
        //         studentId:this.$route.query.studentId
        //     },{
        //         headers: {
        //             token: window.sessionStorage.getItem('ymtxToken')
        //         }
        //     }).then(res=>{
        //         if(res.data.code==2000){
        //             let {name,sexName,school} = res.data.data
        //             this.name=name;
        //             this.school=school;
        //             this.sexName=sexName;
        //
        //         }else{
        //         }
        //     })
        // },
        // change(data){
        //     this.parameter=data
        // }
    }
}
</script>

<style scoped lang="less">

.main{
    background-color: #fff;
    padding-top: 40px;
    min-height: 400px;
    ul {
        width: 800px;
        display: flex;
        flex-wrap: wrap;
        margin: 0 auto;
        justify-content: space-between;
        li {
            box-sizing: border-box;
            padding: 27px;
            text-align: center;
            width: 206px;
            height: 180px;
            box-shadow: 0px 0px 5px 2px #EBF3FE;
            margin-bottom: 40px;
            cursor: pointer;
            img {
                margin-bottom: 30px;
            }
            p {
                font-size: 16px;
                color: #585858;
            }
        }
    }

}

</style>